'use strict';
import $ from 'jquery';

export default class FooterSubscribeForm {
  static init() {
    $('.footer-subscribe').each((index, el) => {
      new FooterSubscribeForm($(el));
    });
  }

  constructor($el) {
    this.el = $el;
    const $form = this.el.find('form');
    $form.on('formReady', (form) => {
      $form.removeClass('mktoForm mktoHasWidth mktoLayoutLeft');
      $form.find('button[type=submit]').removeClass('mktoButton').addClass('subscribe-btn').text("Subscribe");
      $form.find('div[class=mktoAsterix]').addClass('asterisk');
      $form.find('input[id=Email]').addClass('subcribe-input');
    });
    $form.on('submitSuccess', () => {
      $el.find('.subscribe-title-text').remove();
      $form.remove();
      $el.find('.subscribe-disclaimer-text').remove();
      $el.find('.footer-subscribe-thank-you').show();
      return false;
    })
  }
}
